import styled from 'styled-components'

export const Container = styled.table`
margin-top: 1rem;
width: 100%;
font-size: 12px;
border-spacing: 0 .125rem;
font-family: 'Roboto','sans-serif';
thead{
    tr{
        font-weight: 700;
    }
    th:first-child{
        padding-left: 4rem;
        text-align: start;
    }
}

strong{
    font-weight: 700;
    font-size: 14px;
}
span{
    font-size: 13px;
    font-weight: 400;
}

tbody{

    tr{
        background-color: var(--AzulOpacoBg);
    }

    tr,th{
        border-collapse: collapse;
        padding: .25rem .5rem;
    }
}
`
